import { IonContent, IonHeader, IonPage, NavContext } from '@ionic/react';
import { CenteredLoading, MobilePageDetailHeader } from '@tbitop/ui';
import { isUndefined } from 'lodash-es';
import type { PropsWithChildren } from 'react';
import { useContext } from 'react';
import { Refresher } from './refresher';

type DetailPageComponentProps = {
  onPullToRefresh?: () => Promise<unknown>;
  title?: string;
  loading?: boolean;
};

export const MobilePageDetail = ({ children, title, loading, onPullToRefresh }: PropsWithChildren<DetailPageComponentProps>) => {
  const history = useContext(NavContext);

  return (
    <IonPage className="tds-mobile-page-without-footer">
      <IonHeader className="ion-no-border">
        <MobilePageDetailHeader title={title} onBackbuttonClick={history.goBack} />
      </IonHeader>
      <IonContent forceOverscroll={false}>
        {!isUndefined(onPullToRefresh) ? <Refresher onRefresh={onPullToRefresh} /> : null }
        <main className="mx-200 md:mx-400 mt-200">
          {loading ? <CenteredLoading /> : children}
        </main>
      </IonContent>
    </IonPage>
  );
};

